<!-- <p>unauthorised works!</p> -->
<div class="main-unauthorised-div">
    <span class="title alignColumn">Unauthorised</span>
    <span class="content alignColumn">You are attempting to access a page that you do not have authorisation to
        view.</span>
    <div class="button-div alignColumn">
        <button mat-raised-button color="primary" routerLink="/">
            <span>Return to landing page</span>
            <mat-icon>north_east</mat-icon>
        </button>
    </div>
    <span class="content alignColumn">If you think this is a mistake, please contact support.</span>
    <div class="button-div alignColumn">
        <span>
            <a class="app-menu-button" [href]="issueEmailLink" style="padding-top: 0.5em;">
                <button mat-raised-button>
                    <span>Email Support</span>
                    <mat-icon>mail</mat-icon>
                </button>                
            </a>
        </span>
    </div>
</div>